const normalizeHexColor = (hexColor: string): string => {
  if (hexColor.startsWith('#')) {
    return hexColor;
  }
  return `#${hexColor}`;
};

export default normalizeHexColor;
